import { PageRef } from 'providers/page-ref';

export type CoachBillingPageParams = {};

/** Coach Billing dashboard. Reached from the Coaching screen header
 *  affordance. Past the loading and load-error states the template picks the
 *  first matching rail view, in this order: a "Billing Coming Soon" empty
 *  state for an unmigrated coach (in practice every legacy coach, since
 *  nothing writes the block that would migrate them), then app-store fixed
 *  tier, then Paddle per-seat, and finally the legacy metered balance +
 *  statement history. Only the fixed-tier view carries a call to action
 *  ("Change Plan", store platforms only) — the metered view's two CTAs
 *  drove the PayPro rail and went with it in #4359. See
 *  `design-docs/coach-slot-pricing.md`. */
export const ICoachBillingPage: PageRef<CoachBillingPageParams, void> = {
  pageName: 'CoachBillingPage',
} as PageRef<CoachBillingPageParams, void>;
